import type * as React from 'react';
import { post } from '@Domain/Api';
import subjectTypeArchived, {
	type SubjectTypeArchivedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeArchived';
import subjectTypeArchiveFailed, {
	type SubjectTypeArchiveFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeArchiveFailed';
import type ArchiveSubjectType from '@Application/SubjectTypeDefinitions/Commands/ArchiveSubjectType';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectTypeArchivedAction | SubjectTypeArchiveFailedAction;

export default (command: ArchiveSubjectType) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await post<void>(
				`${parameters.api.host}/api/accounts/${command.accountId}/subject-type-definitions/${command.subjectTypeId}/archivals`,
				{},
			);

			const action = subjectTypeArchived({ subjectTypeId: command.subjectTypeId }, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectTypeArchiveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
